export default __webpack_public_path__ + "static/media/under_maintenance.beef664e.gif";